import React from "react";
import { Formik, Field, Form } from 'formik';
import s from './Forgot.module.scss'
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { domain } from "../../store/authSlice.js";

export const Forgot = () => {
    const { t } = useTranslation()
    const serv_url = domain + 'accounts/password-reset/';

    return (
        <div className={s.wrapper}>
        <div>
            <div className={s.container}>
            
                <div className={s.content}>
                    <div className={s.birds}></div>
                    <div className={s.formForgot}>
                        <div className={s.formTittle}>{t('forgotYourPassword')}</div>
                        <div className={s.formText}>{t('enter_email_message')}
                        </div>
                        <div>
                            <Formik
                                initialValues={{
                                    email: '',
                                }}
                                onSubmit={(values) => {
                                    console.log(values);
                                    window.location.href = serv_url;
                                }}>
                                <Form className={s.form}>
                                    <label htmlFor="email">email</label>
                                    <Field className={s.email}
                                        name="email"
                                        type="email" />
                                    <button className={s.signBtn} type="submit">{t("signIn")}</button>
                                </Form>
                            </Formik>
                        </div>
                        <div className={s.formText}>{t('letter_time_message')}</div>
                    </div>
                </div>
            </div>
            <div className={s.upperCloud}></div>
            <div className={s.uuderCloud}></div>
        </div>
        
    </div>
    )
}